module.exports = __webpack_public_path__ + "h5/img/loading.37795b74.gif";